import { useFeatureFlagContext } from '../context/FeatureFlagContext';

/**
 * Custom hook to check if a specific feature flag is enabled.
 * 
 * @param {string} flagName - The name of the feature flag (e.g. 'quickCreate')
 * @param {boolean} [defaultValue=false] - The fallback value if flags are still loading or unavailable
 * @returns {boolean} - true if the flag is enabled, false otherwise
 */
export const useFeatureFlag = (flagName, defaultValue = false) => {
  const { flags, loading } = useFeatureFlagContext();

  // If flags are still loading, you might want to return false or the default value
  // to avoid flashing features, or handle loading states in the UI.
  if (loading) {
    return defaultValue;
  }

  // Return the flag value, or defaultValue if the flag is not defined
  return flags.hasOwnProperty(flagName) ? flags[flagName] : defaultValue;
};
